<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick">
      <v-card>
        <v-card-text>
          <v-textarea
            auto-grow
            outlined
            v-model="notes"
            label="Notes"
            hide-details="auto"
          ></v-textarea>
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { ActivatorButton } from '@/components/pages'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'NotesDialog',

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,
        
        notes: '',
      };
    },

    computed: mapGetters('pros', ['currentPro']),

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.notes = this.currentPro.notes
        }
      },
    },

    methods: {
      ...mapActions('pros', ['updateCurrent']),

      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        await this.updateCurrent({ notes: this.notes })
        this.close()
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position: absolute;
  }
</style>